/* ================================================================
   CBCR · Gallery — Shared JS [v2026-05-10-1]
   ================================================================
   Modulo unico CBCRGallery con sotto-moduli per la pagina Gallery.
   Event delegation ovunque possibile (Impact product-rerender safe).
   Re-init supportato su shopify:section:load.
   ================================================================ */

(function () {
  'use strict';

  var CBCRGallery = window.CBCRGallery || {};
  window.CBCRGallery = CBCRGallery;

  /* ---------- Utilities ---------- */
  function qs(sel, scope) { return (scope || document).querySelector(sel); }
  function qsa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function once(el, key) {
    if (!el) return false;
    if (el.dataset['cbcrGl' + key]) return false;
    el.dataset['cbcrGl' + key] = '1';
    return true;
  }

  /* ---------- Scroll progress ---------- */
  CBCRGallery.scrollProgress = function () {
    var bar = qs('.cbcr-gallery-progress');
    if (!bar) return;
    function update() {
      var scrollTop = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docH > 0 ? (scrollTop / docH * 100) : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  };

  /* ---------- Transparent header ---------- */
  CBCRGallery.transparentHeader = function () {
    var hero = qs('.cbcr-gallery-hero[data-transparent="true"]');
    if (!hero) {
      document.body.removeAttribute('data-gl-transparent-header');
      return;
    }
    document.body.setAttribute('data-gl-transparent-header', 'true');
  };

  /* ---------- Side nav state machine ---------- */
  CBCRGallery.sideNav = function () {
    var nav = qs('.cbcr-gallery-sidenav');
    var dot = qs('.cbcr-gallery-nav__dot');
    var backdrop = qs('.cbcr-gallery-nav__backdrop');
    if (!nav) return;
    var links = qsa('a[data-gl-section]', nav);
    if (!links.length) return;

    var body = document.body;
    var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1025px)').matches;
    var hero = qs('.cbcr-gallery-hero');
    var state = 'in-hero';
    var userOverride = false; /* true quando utente ha espanso manualmente */
    var leaveTimer = null;

    function setState(s) {
      if (state === s) return;
      state = s;
      body.setAttribute('data-gl-nav-state', s);
      if (dot) dot.setAttribute('aria-expanded', s === 'expanded' ? 'true' : 'false');
    }

    function computeFromScroll() {
      if (userOverride) return; /* non sovrascrivere mentre utente interagisce */
      var threshold = hero ? hero.offsetHeight - 80 : 500;
      if (window.scrollY > threshold) setState('collapsed');
      else setState('in-hero');
    }

    /* Init state */
    body.setAttribute('data-gl-nav-state', 'in-hero');
    if (!once(body, 'NavStateInit')) {
      /* Già inizializzato: gli event listener sono già attaccati, esci */
      /* Aggiorna comunque active/click handlers sui link nuovi (rebuild) */
    } else {
      window.addEventListener('scroll', function () {
        computeFromScroll();
      }, { passive: true });

      /* Desktop: hover attorno al dot (zona ~80x140 centrata vert) → expanded */
      if (isDesktop) {
        document.addEventListener('mousemove', function (e) {
          if (state === 'in-hero') return;
          var rightZone = window.innerWidth - 80;
          var centerY = window.innerHeight / 2;
          var inHitZone = e.clientX >= rightZone && Math.abs(e.clientY - centerY) <= 70;
          /* Mantieni espanso se cursore dentro nav stessa */
          var inNav = nav && nav.contains(e.target);
          if (inHitZone || inNav) {
            userOverride = true;
            setState('expanded');
            clearTimeout(leaveTimer);
          } else if (state === 'expanded') {
            clearTimeout(leaveTimer);
            leaveTimer = setTimeout(function () {
              userOverride = false;
              computeFromScroll();
            }, 300);
          }
        });
      }

      /* Click sul dot: toggle expanded */
      if (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          if (state === 'expanded') {
            userOverride = false;
            computeFromScroll();
          } else {
            userOverride = true;
            setState('expanded');
          }
        });
      }

      /* Click sul backdrop (o fuori dal nav): collapse */
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          userOverride = false;
          computeFromScroll();
        });
      }
      document.addEventListener('click', function (e) {
        if (state !== 'expanded') return;
        if (nav.contains(e.target) || (dot && dot.contains(e.target))) return;
        userOverride = false;
        computeFromScroll();
      });
    }

    /* Active state tracking (su ogni chiamata, per re-bind post-rebuild nav) */
    function updateActive() {
      var mid = window.innerHeight * 0.4;
      var active = null;
      links.forEach(function (a) {
        var id = a.getAttribute('data-gl-section');
        var el = document.getElementById(id);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top < mid && r.bottom > mid) active = a;
      });
      links.forEach(function (a) { a.classList.toggle('is-active', a === active); });
    }
    if (once(nav, 'ActiveScroll')) {
      window.addEventListener('scroll', updateActive, { passive: true });
    }
    updateActive();

    /* Click sui link: smooth scroll + collapse se expanded */
    links.forEach(function (a) {
      if (!once(a, 'SideClick')) return;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('data-gl-section');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var rect = target.getBoundingClientRect();
        var top = rect.top + window.scrollY - 40;
        window.scrollTo({ top: top, behavior: 'smooth' });
        if (state === 'expanded') {
          userOverride = false;
          setTimeout(computeFromScroll, 600);
        }
      });
    });

    computeFromScroll();
  };

  /* ---------- Hero parallax: gestito via CSS scroll-driven animation ---------- */
  /* Vedi cbcr-gallery.css `@supports (animation-timeline: scroll())`.
     JS no-op: CSS compositor-driven, no main thread sync, no vibra. */
  CBCRGallery.heroBgParallax = function () {};

  /* ---------- Generic parallax images ---------- */
  CBCRGallery.parallax = function () {
    var els = qsa('[data-gl-parallax]');
    if (!els.length) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var host = el.parentElement;
        if (!host) return;
        var r = host.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          var offset = (r.top - window.innerHeight / 2) * -0.15;
          el.style.transform = 'translateY(' + offset + 'px)';
        }
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  };

  /* ---------- Reveal on scroll ---------- */
  CBCRGallery.revealOnScroll = function () {
    if (!('IntersectionObserver' in window)) {
      qsa('.cbcr-gallery-reveal, .cbcr-gallery-archive__tile').forEach(function (el) {
        el.classList.add('is-in-view');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    qsa('.cbcr-gallery-reveal, .cbcr-gallery-archive__tile').forEach(function (el) {
      if (once(el, 'Reveal')) io.observe(el);
    });
  };

  /* ---------- Lightbox ---------- */
  CBCRGallery.lightbox = function () {
    var box = qs('.cbcr-gallery-lightbox');
    if (!box) return;
    var img = qs('[data-gl-lightbox-img]', box);
    var titleEl = qs('[data-gl-lightbox-title]', box);
    var tagEl = qs('[data-gl-lightbox-tag]', box);
    var closeBtn = qs('.cbcr-gallery-lightbox__close', box);

    var MIN_SCALE = 1;
    var MAX_SCALE = 4;
    var DBL_SCALE = 2.5;
    var DRAG_THRESHOLD = 5;
    var state = { scale: 1, tx: 0, ty: 0 };
    var pinch = null;
    var pan = null;
    var mouseDrag = null;
    var dragMoved = false;
    var lastTap = 0;
    var lastTouchEnd = 0;

    function applyTransform(animate) {
      if (!img) return;
      img.style.transition = animate ? 'transform 0.25s cubic-bezier(.22,.61,.36,1)' : 'none';
      img.style.transform = 'translate(' + state.tx + 'px,' + state.ty + 'px) scale(' + state.scale + ')';
    }

    function clampPan() {
      if (state.scale <= 1) { state.tx = 0; state.ty = 0; return; }
      var rect = img.getBoundingClientRect();
      var natW = rect.width / state.scale;
      var natH = rect.height / state.scale;
      var maxX = Math.max(0, (natW * state.scale - natW) / 2);
      var maxY = Math.max(0, (natH * state.scale - natH) / 2);
      if (state.tx > maxX) state.tx = maxX;
      if (state.tx < -maxX) state.tx = -maxX;
      if (state.ty > maxY) state.ty = maxY;
      if (state.ty < -maxY) state.ty = -maxY;
    }

    function resetZoom(animate) {
      state.scale = 1; state.tx = 0; state.ty = 0;
      applyTransform(animate);
      box.classList.remove('is-zoomed');
    }

    function setScale(newScale, originX, originY) {
      newScale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
      if (img) {
        var rect = img.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var ox = (originX - cx) / state.scale;
        var oy = (originY - cy) / state.scale;
        state.tx -= ox * (newScale - state.scale);
        state.ty -= oy * (newScale - state.scale);
      }
      state.scale = newScale;
      clampPan();
      box.classList.toggle('is-zoomed', state.scale > 1.01);
    }

    function getDist(t1, t2) {
      var dx = t2.clientX - t1.clientX;
      var dy = t2.clientY - t1.clientY;
      return Math.hypot(dx, dy);
    }
    function getMid(t1, t2) {
      return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 };
    }

    function onTouchStart(e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        pan = null;
        var mid = getMid(e.touches[0], e.touches[1]);
        pinch = {
          startDist: getDist(e.touches[0], e.touches[1]),
          startScale: state.scale,
          startTx: state.tx,
          startTy: state.ty,
          midX: mid.x,
          midY: mid.y
        };
      } else if (e.touches.length === 1) {
        var now = Date.now();
        var t = e.touches[0];
        if (now - lastTap < 300) {
          e.preventDefault();
          if (state.scale > 1.01) resetZoom(true);
          else { setScale(DBL_SCALE, t.clientX, t.clientY); applyTransform(true); }
          lastTap = 0;
          return;
        }
        lastTap = now;
        if (state.scale > 1.01) {
          pan = { startX: t.clientX, startY: t.clientY, startTx: state.tx, startTy: state.ty };
        }
      }
    }

    function onTouchMove(e) {
      if (pinch && e.touches.length === 2) {
        e.preventDefault();
        var d = getDist(e.touches[0], e.touches[1]);
        var newScale = pinch.startScale * (d / pinch.startDist);
        setScale(newScale, pinch.midX, pinch.midY);
        applyTransform(false);
      } else if (pan && e.touches.length === 1) {
        e.preventDefault();
        var t = e.touches[0];
        state.tx = pan.startTx + (t.clientX - pan.startX);
        state.ty = pan.startTy + (t.clientY - pan.startY);
        clampPan();
        applyTransform(false);
      }
    }

    function onTouchEnd(e) {
      if (e.touches.length < 2) pinch = null;
      if (e.touches.length < 1) {
        pan = null;
        if (state.scale < 1.01) resetZoom(true);
      }
      lastTouchEnd = Date.now();
    }

    function onWheel(e) {
      if (!img) return;
      e.preventDefault();
      var delta = -e.deltaY;
      var factor = delta > 0 ? 1.1 : 0.9;
      setScale(state.scale * factor, e.clientX, e.clientY);
      applyTransform(false);
    }

    function open(src, title, tag) {
      if (img) img.src = src;
      if (titleEl) titleEl.textContent = title || '';
      if (tagEl) tagEl.textContent = tag || '';
      resetZoom(false);
      box.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      box.classList.remove('is-active');
      document.body.style.overflow = '';
      resetZoom(false);
      if (img) img.src = '';
    }

    CBCRGallery._openLightbox = open;
    CBCRGallery._closeLightbox = close;

    if (once(box, 'LightboxInit')) {
      box.addEventListener('click', function (e) {
        if (closeBtn && closeBtn.contains(e.target)) return;
        /* Skip synthetic click after touchend (mobile fires click ~0-500ms post-tap) */
        if (Date.now() - lastTouchEnd < 600) return;
        if (dragMoved) { dragMoved = false; return; }
        /* Img usa object-fit: contain → layout box (max 90vw × 85vh) contiene
           letterbox/pillarbox attorno al contenuto visibile. Hit-area = contenuto
           visibile, non layout. Calcola content bounds dentro layout via aspect ratio. */
        if (img && img.naturalWidth) {
          var rect = img.getBoundingClientRect();
          var lw = rect.width / state.scale;
          var lh = rect.height / state.scale;
          var natAspect = img.naturalWidth / img.naturalHeight;
          var layoutAspect = lw / lh;
          var cw, ch;
          if (layoutAspect > natAspect) { ch = lh; cw = ch * natAspect; }
          else { cw = lw; ch = cw / natAspect; }
          var lcx = (rect.left + rect.right) / 2 - state.tx;
          var lcy = (rect.top + rect.bottom) / 2 - state.ty;
          var inside = e.clientX >= lcx - cw / 2 && e.clientX <= lcx + cw / 2 &&
                       e.clientY >= lcy - ch / 2 && e.clientY <= lcy + ch / 2;
          if (inside) {
            if (state.scale > 1.01) resetZoom(true);
            else { setScale(DBL_SCALE, e.clientX, e.clientY); applyTransform(true); }
            return;
          }
        }
        close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      if (closeBtn) closeBtn.addEventListener('click', close);
      /* Cursore dinamico basato su content bounds (non layout box). */
      function isOverContent(x, y) {
        if (!img || !img.naturalWidth) return false;
        var rect = img.getBoundingClientRect();
        var lw = rect.width / state.scale;
        var lh = rect.height / state.scale;
        var natAspect = img.naturalWidth / img.naturalHeight;
        var layoutAspect = lw / lh;
        var cw, ch;
        if (layoutAspect > natAspect) { ch = lh; cw = ch * natAspect; }
        else { cw = lw; ch = cw / natAspect; }
        var lcx = (rect.left + rect.right) / 2 - state.tx;
        var lcy = (rect.top + rect.bottom) / 2 - state.ty;
        return x >= lcx - cw / 2 && x <= lcx + cw / 2 && y >= lcy - ch / 2 && y <= lcy + ch / 2;
      }
      box.addEventListener('mousemove', function (e) {
        if (closeBtn && closeBtn.contains(e.target)) { box.setAttribute('data-cbcr-lb-cur', 'default'); return; }
        var over = isOverContent(e.clientX, e.clientY);
        var cur = 'default';
        if (over) cur = mouseDrag ? 'grabbing' : (state.scale > 1.01 ? 'grab' : 'zoom-in');
        box.setAttribute('data-cbcr-lb-cur', cur);
      });
      if (img) {
        img.addEventListener('touchstart', onTouchStart, { passive: false });
        img.addEventListener('touchmove', onTouchMove, { passive: false });
        img.addEventListener('touchend', onTouchEnd);
        img.addEventListener('touchcancel', onTouchEnd);
        img.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          e.preventDefault();
          if (state.scale > 1.01) {
            mouseDrag = { startX: e.clientX, startY: e.clientY, startTx: state.tx, startTy: state.ty };
            dragMoved = false;
          }
        });
        document.addEventListener('mousemove', function (e) {
          if (!mouseDrag) return;
          var dx = e.clientX - mouseDrag.startX;
          var dy = e.clientY - mouseDrag.startY;
          if (!dragMoved && Math.hypot(dx, dy) > DRAG_THRESHOLD) dragMoved = true;
          state.tx = mouseDrag.startTx + dx;
          state.ty = mouseDrag.startTy + dy;
          clampPan();
          applyTransform(false);
        });
        document.addEventListener('mouseup', function () {
          mouseDrag = null;
        });
        /* Click delegato al box handler (gestisce sia toggle zoom su img che
           close su side band con check layout-bounds vs visual-bounds). */
        img.addEventListener('wheel', onWheel, { passive: false });
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-gl-lightbox]');
      if (!trigger) return;
      if (trigger.tagName === 'A' && trigger.getAttribute('href') && trigger.getAttribute('href') !== '#') return;
      e.preventDefault();
      var src = trigger.getAttribute('data-gl-lightbox-src') || trigger.getAttribute('data-gl-lightbox');
      var title = trigger.getAttribute('data-gl-lightbox-title') || '';
      var tag = trigger.getAttribute('data-gl-lightbox-tag') || '';
      open(src, title, tag);
    });
  };

  /* ---------- Archive filter ---------- */
  CBCRGallery.archiveFilter = function () {
    qsa('.cbcr-gallery-archive').forEach(function (scope) {
      if (!once(scope, 'FilterInit')) return;
      var filters = qsa('.cbcr-gallery-archive__filter', scope);
      var tiles = qsa('.cbcr-gallery-archive__tile', scope);
      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filters.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var f = btn.getAttribute('data-filter');
          tiles.forEach(function (tile, i) {
            var cat = tile.getAttribute('data-cat');
            if (f === 'all' || cat === f) {
              tile.style.display = '';
              tile.style.animation = 'none';
              void tile.offsetHeight;
              tile.style.animation = 'cbcrGlTileIn 0.7s cubic-bezier(.22, .61, .36, 1) forwards';
              tile.style.animationDelay = ((i % 3) * 0.08) + 's';
            } else {
              tile.style.display = 'none';
            }
          });
        });
      });
    });
  };

  /* ---------- Archive carousel ---------- */
  CBCRGallery.archiveCarousel = function () {
    qsa('.cbcr-gallery-archive').forEach(function (scope) {
      if (!once(scope, 'CarouselInit')) return;
      var track = qs('.cbcr-gallery-archive__grid', scope);
      var prev = qs('.cbcr-gallery-archive__arrow--prev', scope);
      var next = qs('.cbcr-gallery-archive__arrow--next', scope);
      if (!track || !prev || !next) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max;
      }

      var animating = false;

      function getStep() {
        /* Scroll di 1 tile per click su tutte le carousel (Gallery Archive + Makers). */
        var tile = qs('.cbcr-gallery-archive__tile', track);
        if (!tile) return track.clientWidth;
        var gapPx = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return tile.getBoundingClientRect().width + gapPx;
      }

      function animateTo(target) {
        if (animating) return;
        var max = track.scrollWidth - track.clientWidth;
        target = Math.max(0, Math.min(max, target));
        var start = track.scrollLeft;
        var change = target - start;
        if (Math.abs(change) < 1) return;
        animating = true;
        var t0 = performance.now();
        var dur = 100;
        function tick(now) {
          var p = Math.min((now - t0) / dur, 1);
          /* easeInOutQuart — long decel, partenza dolce, niente snap. */
          var e = p < 0.5
            ? 8 * p * p * p * p
            : 1 - Math.pow(-2 * p + 2, 4) / 2;
          track.scrollLeft = start + change * e;
          if (p < 1) {
            requestAnimationFrame(tick);
          } else {
            animating = false;
            update();
          }
        }
        requestAnimationFrame(tick);
      }

      prev.addEventListener('click', function () { animateTo(track.scrollLeft - getStep()); });
      next.addEventListener('click', function () { animateTo(track.scrollLeft + getStep()); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      qsa('.cbcr-gallery-archive__filter', scope).forEach(function (btn) {
        btn.addEventListener('click', function () {
          animateTo(0);
          setTimeout(update, 500);
        });
      });

      update();
    });
  };

  /* ---------- Materials touch reveal ---------- */
  CBCRGallery.materialsTouch = function () {
    qsa('.cbcr-gallery-mat__strip').forEach(function (strip) {
      if (!once(strip, 'MatTouchInit')) return;
      function cellAt(x, y) {
        var el = document.elementFromPoint(x, y);
        return el && el.closest ? el.closest('.cbcr-gallery-mat__cell') : null;
      }
      function highlight(cell) {
        qsa('.cbcr-gallery-mat__cell.is-touched', strip).forEach(function (c) { if (c !== cell) c.classList.remove('is-touched'); });
        if (cell) cell.classList.add('is-touched');
      }
      function clearAll() {
        strip.classList.remove('is-touching');
        qsa('.cbcr-gallery-mat__cell.is-touched', strip).forEach(function (c) { c.classList.remove('is-touched'); });
      }
      strip.addEventListener('touchstart', function (e) {
        strip.classList.add('is-touching');
        var t = e.touches[0];
        highlight(cellAt(t.clientX, t.clientY));
      }, { passive: true });
      strip.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        highlight(cellAt(t.clientX, t.clientY));
      }, { passive: true });
      strip.addEventListener('touchend', clearAll);
      strip.addEventListener('touchcancel', clearAll);
    });
  };

  /* ---------- Touch illuminate (Android :hover delay workaround) ---------- */
  CBCRGallery.touchIlluminate = function () {
    var selector = [
      '.cbcr-info-grid__card',
      '.cbcr-gallery-archive__tile',
      '.cbcr-gallery-featured__visual',
      '.cbcr-gallery-split__visual'
    ].join(',');
    qsa(selector).forEach(function (el) {
      if (!once(el, 'TouchIlluminateInit')) return;
      el.addEventListener('touchstart', function () {
        el.classList.add('is-touching');
      }, { passive: true });
      var clear = function () { el.classList.remove('is-touching'); };
      el.addEventListener('touchend', clear);
      el.addEventListener('touchcancel', clear);
    });
  };

  /* ---------- Auto roman index ---------- */
  var romanMap = [['x', 10], ['ix', 9], ['v', 5], ['iv', 4], ['i', 1]];
  function toRoman(n) {
    var r = '';
    romanMap.forEach(function (p) {
      while (n >= p[1]) { r += p[0]; n -= p[1]; }
    });
    return r + '.';
  }
  CBCRGallery.autoRomanIndex = function () {
    qsa('.cbcr-gallery-archive').forEach(function (scope) {
      qsa('[data-gl-roman-auto]', scope).forEach(function (el, i) {
        var existing = (el.textContent || '').trim();
        if (!existing) el.textContent = toRoman(i + 1);
      });
    });
  };

  /* ---------- FAQ accordion (single open) ---------- */
  CBCRGallery.faqAccordion = function () {
    qsa('.cbcr-gallery-faq').forEach(function (scope) {
      if (!once(scope, 'FaqInit')) return;
      var items = qsa('.cbcr-gallery-faq__item', scope);
      items.forEach(function (item) {
        var trigger = qs('.cbcr-gallery-faq__trigger', item);
        var body = qs('.cbcr-gallery-faq__body', item);
        if (!trigger || !body) return;

        function set(expanded) {
          item.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (expanded) {
            body.style.maxHeight = body.scrollHeight + 40 + 'px';
          } else {
            body.style.maxHeight = '0px';
          }
        }

        trigger.addEventListener('click', function () {
          var isOpen = item.getAttribute('aria-expanded') === 'true';
          items.forEach(function (other) {
            if (other !== item) {
              other.setAttribute('aria-expanded', 'false');
              var oBody = qs('.cbcr-gallery-faq__body', other);
              var oTrig = qs('.cbcr-gallery-faq__trigger', other);
              if (oBody) oBody.style.maxHeight = '0px';
              if (oTrig) oTrig.setAttribute('aria-expanded', 'false');
            }
          });
          set(!isOpen);
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger.click(); }
        });
        set(false);
      });
    });
  };

  /* ---------- Magnetic buttons ---------- */
  CBCRGallery.magneticButtons = function () {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    qsa('.cbcr-gallery-btn--gold, .cbcr-gallery-btn--outline-gold').forEach(function (btn) {
      if (!once(btn, 'Magnetic')) return;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15) + 'px, ' + (y * 0.2) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  };

  /* ---------- Before/After (delegates to cbcr-about.js if present) ---------- */
  CBCRGallery.beforeAfter = function () {
    if (typeof window.initCbcrBeforeAfter === 'function') {
      window.initCbcrBeforeAfter();
      return;
    }
    qsa('.cbcr-ba__slider').forEach(function (slider) {
      if (!once(slider, 'BaInit')) return;
      var after = slider.querySelector('.cbcr-ba__img--after');
      var handle = slider.querySelector('.cbcr-ba__handle');
      if (!after || !handle) return;
      var dragging = false;

      function setPosition(pct) {
        pct = Math.max(0, Math.min(100, pct));
        after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
        handle.style.left = pct + '%';
      }
      function getPct(clientX) {
        var rect = slider.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      slider.addEventListener('mousedown', function (e) { dragging = true; setPosition(getPct(e.clientX)); e.preventDefault(); });
      document.addEventListener('mousemove', function (e) { if (dragging) setPosition(getPct(e.clientX)); });
      document.addEventListener('mouseup', function () { dragging = false; });
      slider.addEventListener('touchstart', function (e) { dragging = true; setPosition(getPct(e.touches[0].clientX)); }, { passive: true });
      slider.addEventListener('touchmove', function (e) { if (dragging) setPosition(getPct(e.touches[0].clientX)); }, { passive: true });
      slider.addEventListener('touchend', function () { dragging = false; });
      slider.addEventListener('click', function (e) { setPosition(getPct(e.clientX)); });

      var initial = parseFloat(slider.getAttribute('data-initial-position'));
      if (isNaN(initial)) initial = 50;
      setPosition(initial);
    });
  };

  /* ---------- Makers section bridge ----------
     La sezione cbcr-about-family usa classi `.cbcr-makers-*` per non dipendere
     da cbcr-gallery.css (le sue regole vivono in cbcr-about.css con i nuovi nomi).
     La logica JS (carousel/reveal/lightbox/roman) e' identica → al boot aggiungiamo
     le classi `.cbcr-gallery-*` alle stesse istanze makers cosi' gli handler esistenti
     le coprono senza duplicare codice. cbcr-gallery.css NON e' caricato sulla pagina
     About → niente conflitto CSS. */
  CBCRGallery.aliasMakers = function () {
    var pairs = [
      ['cbcr-makers-archive', 'cbcr-gallery-archive'],
      ['cbcr-makers-archive__head', 'cbcr-gallery-archive__head'],
      ['cbcr-makers-archive__carousel', 'cbcr-gallery-archive__carousel'],
      ['cbcr-makers-archive__grid', 'cbcr-gallery-archive__grid'],
      ['cbcr-makers-archive__arrow', 'cbcr-gallery-archive__arrow'],
      ['cbcr-makers-archive__arrow--prev', 'cbcr-gallery-archive__arrow--prev'],
      ['cbcr-makers-archive__arrow--next', 'cbcr-gallery-archive__arrow--next'],
      ['cbcr-makers-archive__tile', 'cbcr-gallery-archive__tile'],
      ['cbcr-makers-archive__tile-caption', 'cbcr-gallery-archive__tile-caption'],
      ['cbcr-makers-archive__tile-index', 'cbcr-gallery-archive__tile-index'],
      ['cbcr-makers-reveal', 'cbcr-gallery-reveal']
    ];
    pairs.forEach(function (p) {
      qsa('.' + p[0]).forEach(function (el) { el.classList.add(p[1]); });
    });
  };

  /* ---------- Boot ---------- */
  function boot() {
    CBCRGallery.aliasMakers();
    CBCRGallery.scrollProgress();
    CBCRGallery.transparentHeader();
    CBCRGallery.sideNav();
    CBCRGallery.heroBgParallax();
    CBCRGallery.parallax();
    CBCRGallery.revealOnScroll();
    CBCRGallery.lightbox();
    CBCRGallery.archiveFilter();
    CBCRGallery.archiveCarousel();
    CBCRGallery.materialsTouch();
    CBCRGallery.touchIlluminate();
    CBCRGallery.autoRomanIndex();
    CBCRGallery.faqAccordion();
    CBCRGallery.magneticButtons();
    CBCRGallery.beforeAfter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify editor re-init */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.id && e.target.id.indexOf('cbcr-gallery') === -1 &&
        e.target.id.indexOf('cbcr-about-family') === -1 &&
        !e.target.querySelector('.cbcr-gallery-section') &&
        !e.target.querySelector('.cbcr-makers-section')) return;
    boot();
  });
})();
